import React, { useEffect, useState } from 'react';
import { KuposButton, KuposSteps, KuposSuccessFailure } from '../../../common';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actions from './../../redux/actions';
import * as homeActions from '../../../home/redux/actions';
import CommonService from '../../../../services/commonService';
import { AppData } from '../../../../services';
import CuponeraBookingInputs from '../../../common/Cuponera/BookingInputs/CuponeraBookingInputs';
import CuponeraInputs from '../../../common/Cuponera/CuponeraInputs';

const CuponeraSeatsSelection = (props) => {
  const stepsMenu = [
    { label: 'GOING', active: true },
    { label: 'PAYMENT' },
    { label: 'CONFIRMATION' },
  ];
  let bufferSeats = [];
  let bufferCityPairs = [];

  const [selectedSeats, setSelectedSeats] = useState(null);

  const [seats, setSeats] = useState([]);
  const [travelOps, setTravelOps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cityPairs, setCityPairs] = useState([]);
  const [uniqCityPairs, setUniqCityPairs] = useState([]);
  const [selectOptionsUpdate, setSelectOptionsUpdate] = useState('');
  const [selectOptions2Update, setSelectOptions2Update] = useState('');
  const [selectOptions, setSelectOptions] = useState('');
  const [selectOptions2, setSelectOptions2] = useState('');

  let allCities = props.home.uniqueCities;
  useEffect(() => {
    if (!selectOptionsUpdate && allCities) {
      setSelectOptions(allCities);
      setSelectOptionsUpdate(true);
    }
    if (!selectOptions2Update && allCities) {
      setSelectOptions2(allCities);
      setSelectOptions2Update(true);
    }
  });

  useEffect(() => {
    let flatArr = cityPairs.flat(2);

    const uniqueArray = [];
    flatArr.forEach((element, i) => {
      if (uniqueArray.length === 0) {
        uniqueArray.push(element);
      } else {
        if (!isPresent(uniqueArray, element)) {
          uniqueArray.push(element);
        }
      }
    });
    setUniqCityPairs(uniqueArray);
  }, [cityPairs]);

  //check if some element is present in an array
  const isPresent = (arr, ele) => {
    let present = false;
    arr.forEach((val) => {
      if (val.origin === ele.origin && val.destination === ele.destination) {
        present = true;
      }
    });

    if (present) return true;

    return false;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (props.home && props.home.metaData && props.home.metaData.pullman_travel_ids)
      setTravelOps(props.home.metaData.pullman_travel_ids);
  }, [props]);

  useEffect(() => {
    let source = sessionStorage.getItem('cuponeraSourceCity');
    let dest = sessionStorage.getItem('cuponeraDestCity');

    if (source && dest && loading) {
      source = JSON.parse(source);
      dest = JSON.parse(dest);
      if (source.value && dest.value && travelOps) {
        let myTimeout;
        travelOps.forEach((op) => {
          myTimeout = setTimeout(() => {
            getCoupensApi(source.value, dest.value, op);
          }, 1000);
        });
        return () => {
          clearTimeout(myTimeout);
        };
      }
    }
  }, [sessionStorage, travelOps, loading]);

  const getCoupensApi = (origin, dest, op) => {
    let key = `${origin}-${dest}`;

    props.actions
      .apiCall({
        url:
          AppData.BASE_URL +
          `api/services/get_zone_creation_details.json?origin_id=${origin}&destination_id=${dest}&api_travel_id=${op}`,
        method: 'GET',
        type: 'cuponera',
      })
      .then((res) => {
        setLoading(false);
        if (res && res.data && res.data.data && res.data.data.data) {
          // let oldSeats = CommonService.copyObject(seats);
          let newSeats = res.data.data.data[key];

          if (Array.isArray(newSeats)) {
            newSeats.forEach((val) => {
              bufferSeats.push({
                ...val,
                active: false,
                seat_type: 'Salón Cama',
                api_travel_id: op,
              });
              bufferCityPairs.push(val.city_pairs);
            });
            setSeats(bufferSeats);
            setCityPairs(bufferCityPairs);
          }
        }
      });
  };
  const SummarySection = ({ selectedSeats }) => {
    return (
      <div style={styles.summary_outer_box}>
        <div style={styles.summary_outer}>
          <div style={styles.summary} className="kupos-card">
            <div className="bold-text font12">Detalles de la compra</div>
            <div style={styles.yellow_line}></div>

            {selectedSeats && (
              <div>
                <div style={styles.operator_details}>
                  <div className="font9" style={styles.operator}>
                    {selectedSeats.operator_name}
                  </div>
                  <div className="font9">{selectedSeats.no_of_coupons} Pasajes</div>
                </div>

                <div style={styles.location_details}>
                  <Place
                    icon={'/images/search-bar/search-bar-origin.svg'}
                    location={selectedSeats.origin}
                    active={true}
                  />
                  <Place
                    icon={'/images/search-bar/search-bar-destination.svg'}
                    location={selectedSeats.destination}
                    active={true}
                  />
                </div>

                <div style={styles.line}></div>

                <div style={styles.seats_details} className="font11">
                  <div className="font9">{selectedSeats.no_of_coupons} pasajes</div>
                  <div className="font9 bold-text">
                    CLP {CommonService.currency(selectedSeats.total_coupon_amount)}
                  </div>
                </div>
              </div>
            )}
          </div>
          {selectedSeats && (
            <div style={styles.price_tag_selected}>
              <div className="font10 bold-text">TOTAL</div>
              <div className="font10 bold-text">
                CLP {CommonService.currency(selectedSeats.total_coupon_amount)}
              </div>
            </div>
          )}

        </div>

        <div style={styles.button_container}>
          <KuposButton
            onClick={onContinue}
            style={styles.button}
            disabled={selectedSeats ? false : true}
          >
            {props.t('RESULTS_PAGE.CONTINUE')}
          </KuposButton>
        </div>


      </div>
    );
  };

  const onStepClick = () => { };

  const onContinue = () => {
    props.history.push('/cuponera/payment');
  };

  const selectSeat = (item, index) => {
    setSelectedSeats(item);

    props.actions.setCuponeraSeats(item);

    sessionStorage.setItem('cuponeraSeats', JSON.stringify(item));

    let seatsLocal = [];

    seats.map((seat, i) => {
      if (i === index) {
        seatsLocal.push({ ...seat, active: true });
      } else {
        seatsLocal.push({ ...seat, active: false });
      }
    });

    setSeats(seatsLocal);
  };

  console.log({ seats });

  const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
    if (rawArray && itemToRemove) {
      return rawArray
        .map(function (obj) {
          if (obj.label == itemToRemove.label) {
          } else {
            return obj;
          }
        })
        .filter(function (obj) {
          return typeof obj !== 'undefined';
        });
    } else if (!itemToRemove) {
      // return rawArray;
    }
  };
  const onInputChange = (val, type) => { };

  const onInputChange2 = (val, type) => { };

  const renderNoResultsFoundPage = () => {
    return (
      <div className="no-results-found">
        <KuposSuccessFailure
          title={props.t('HOME.WE_ARE_SORRY')}
          subtitle={props.t('HOME.NO_COUPONS_FOUND')}
          infoText={props.t('HOME.TRY_OTHER_ROUTES')}
          t={props.t}
        >
          <div className="kupos-card">
            <CuponeraInputs
              t={props.t}
              selectOptions={selectOptions}
              selectOptions2={selectOptions2}
              onInputChange={onInputChange}
              onInputChange2={onInputChange2}
              getOriginSelectedFilteredDestinations={getOriginSelectedFilteredDestinations}
              history={props.history}
              actions={props.actions}
              common={props.common}
              loading={() => setLoading(true)}
              allProps={props}
            />
          </div>
        </KuposSuccessFailure>
      </div>
    );
  };

  return (
    <div>
      {!seats || (seats && seats.length <= 0 && !loading) ? (
        renderNoResultsFoundPage()
      ) : (
        <div className="content-container">
          <KuposSteps menuButtons={stepsMenu} t={props.t} onStepClick={onStepClick} />

          <div style={styles.outer_main_container}>
            <div style={styles.cards_and_button}>
              {loading ? (
                <div className="loader-cricle" style={{ background: '#013ba7' }}></div>
              ) : (
                <SeatsSection seats={seats} selectSeat={selectSeat} />
              )}

              {uniqCityPairs && uniqCityPairs.length && selectedSeats ? (
                <Description cityPairs={uniqCityPairs} />
              ) : null}

              {/* <div style={styles.button_container}>
                <KuposButton
                  onClick={onContinue}
                  style={styles.button}
                  disabled={selectedSeats ? false : true}
                >
                  {props.t('RESULTS_PAGE.CONTINUE')}
                </KuposButton>
              </div> */}
            </div>

            <SummarySection selectedSeats={selectedSeats} />
          </div>
        </div>
      )}
    </div>
  );
};

const SeatsSection = ({ seats, selectSeat }) => {
  return (
    <div style={styles.cards_container}>
      {(seats || []).map((seatItem, index) => {
        return (
          <div
            style={styles.seat_item_outer}
            key={index}
            onClick={() => selectSeat(seatItem, index)}
            className="cuponera_seat_item"
          >
            <div style={styles.seat_item} className="kupos-card">
              <div style={styles.seat_count}>
                <div style={styles.title} className="font12">
                  Cuponera
                </div>
                <div
                  style={seatItem.active ? { color: '#fa5e00' } : { color: '#464647' }}
                  className="bold-text font12"
                >
                  {seatItem.no_of_coupons} Pasajes
                </div>
              </div>
              <div style={styles.line}></div>

              <div style={styles.op_details}>
                <div className="font9" style={styles.title}>
                  Empresa
                </div>
                <div className="font11 bold-text">{seatItem.operator_name}</div>
              </div>

              <div style={styles.place_details}>
                <Place
                  icon={'/images/search-bar/search-bar-origin.svg'}
                  location={seatItem.origin}
                  active={seatItem.active}
                />

                <Place
                  icon={'/images/search-bar/search-bar-destination.svg'}
                  location={seatItem.destination}
                  active={seatItem.active}
                />
              </div>

              {/* <div style={styles.seat_type_details}>
                <div className="font11" style={styles.title}>
                  Tipos de asiento
                </div>
                <div className="font11 bold-text">{seatItem.seat_type}</div>
              </div> */}
            </div>

            <div
              style={styles.price_tag}
              className={seatItem.active ? 'colored_background price_tag' : 'price_tag'}
            >
              <div className="font11 bold-text">Total</div>
              <div className="font11 bold-text">
                CLP {CommonService.currency(seatItem.total_coupon_amount)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const Description = ({ cityPairs }) => {
  return (
    <div style={styles.desc_container} className="kupos-card">
      <div style={styles.title} className="font9 bold-text">
        Información importante
      </div>
      <div style={styles.line_1} className="font9">
        La cuponera es un producto de Pullman Bus que te permite comprar una cantidad de pasajes en blanco a un precio preferencial, para ser usados en orígenes y destinos específicos.
      </div>
      <div style={styles.section_2}>
        <div style={styles.title} className="font9 bold-text">
          La cuponera que seleccionaste puede ser utilizada en los siguientes orígenes y destinos (tanto ida como ida y vuelta):
        </div>

        <div style={styles.location_pairs_list}>
          {cityPairs.map((cityPair, i) => {
            return <LocationPair from={cityPair.origin} to={cityPair.destination} index={i} />;
          })}

        </div>


      </div>
    </div>
  );
};

const LocationPair = ({ from, to, index }) => {
  return (
    <div style={styles.location_pair} className="font9" key={index}>
      - <span className="bold-text">{from}</span> a <span className="bold-text">{to}</span>
    </div>
  );
};

const Place = ({ icon, location, active }) => {
  return (
    <div style={styles.place}>
      <img
        src={icon}
        style={
          active
            ? { width: 22, height: 'auto' }
            : { width: 22, height: 'auto', filter: 'grayscale(100%)' }
        }
        alt="place"
      />
      <span className="font9">{location}</span>
    </div>
  );
};

const styles = {
  outer_main_container: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    gap: 20,
  },
  cards_container: {
    // display: 'flex',
    // justifyContent: 'space-between',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 20,
    rowGap: 60,
  },

  seat_item_outer: {
    position: 'relative',
    flex: 1,
    cursor: 'pointer',
  },
  seat_item: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    borderRadius: 8,
    zIndex: 10,
    position: 'relative',
  },
  title: {
    marginBottom: 6,
  },
  seat_count: {},
  line: {
    height: 1,
    backgroundColor: '#bbb',
    marginTop: 22,
    marginBottom: 22,
  },
  place_details: {
    marginTop: 22,
  },
  place: {
    display: 'flex',
    marginBottom: 6,
    alignItems: 'center',
  },
  place_icon: {
    width: 22,
    height: 'auto',
  },
  seat_type_details: {
    marginTop: 22,
  },
  price_tag: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#aaa',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginTop: -20,
    paddingTop: 18,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingLeft: 20,
    color: 'white',
  },
  price_tag_selected: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fa5e00',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginTop: -20,
    bottom: -22,
    paddingTop: 28,
    paddingBottom: 10,
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingLeft: 20,
    color: 'white',
    zIndex: -1,
  },

  summary_outer_box: {
    position: 'relative',
    width: '100%',
  },

  summary_outer: {
    width: '17.6%',
    position: 'fixed',
    top: 160,
    // zIndex: 100,
  },
  summary: {
    // width: '17.6%',
    // position: 'fixed',
    // top: 160,
    zIndex: 100,
  },

  yellow_line: {
    height: 3,
    backgroundColor: '#f6ca3d',
    width: '45%',
    marginTop: 16,
    marginBottom: 16,
  },
  button_container: {
    // margin: '80px 40% 10px',
    position: "fixed",
    top: 540,
    // right: 100
    marginLeft: 100
  },
  button: {
    width: '100%',
  },
  desc_container: {
    marginTop: 46,
    padding: 20
  },
  line_1: {},
  section_2: {
    marginTop: 22,
  },

  location_pairs_list: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr"
  },
  location_pair: {
    margin: '20px 0',
  },
  operator_details: {
    margin: '12px 0',
  },
  operator: {
    marginBottom: 6,
  },
  location_details: {
    margin: '22px 0',
  },
  seats_details: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '42px 0',
  },
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(CuponeraSeatsSelection));



// WEBPACK FOOTER //
// ./src/features/home/Cuponera/SeatsSelection/index.js